import { createClient } from "@smfa/utils";
const baseUrl = process.env?.API_URL || process.env?.REACT_APP_BACKEND_URL;

const axios = createClient({ baseUrl, isAdminSite: true });

export const getCancelPolicy = (data) => {
  return axios.get("/cancelpolicy", data ? { params: data } : {});
};

export const updateCancelPolicy = (data) => {
  return axios.post("/cancelpolicyupdate", data);
};
